module.exports = __webpack_public_path__ + "static/media/loading.a27aa85d.gif";